/*
 * PowerPoint host strategy.
 * Delegates to the co-located PowerPointHost class which wires up the shared
 * chat UI, agent service, and PowerPoint action handlers.
 */

import type { IHostStrategy } from "../host-strategy";

export class PowerPointHostStrategy implements IHostStrategy {
  readonly hostType = "PowerPoint";

  async init(): Promise<void> {
    const { PowerPointHost } = await import("./powerpoint");
    await new PowerPointHost().init();
  }
}
